<app-dialog
    [dialogWithInput]="dialog">

    <div class="row">
        <div class="col-12" *ngIf="!dialog.input.paymentRequestId">
            <app-card-v2 [hideHeader]="true">
                <div class="row">
                    <app-form-field label="Demandes de paiements" [required]="true" [size]="12">
                        <app-multiple-select-filter-simple [parentFormGroup]="formGroup"
                                                           [loading]="paymentRequestFindAllSelectService.loading$ | async"
                                                           parentFormControlName="paymentRequestIds"
                                                           [elements]="paymentRequestsElements"
                                                            (selectionChangedEvent)="refreshBalanceFromUI($event)"></app-multiple-select-filter-simple>
                    </app-form-field>
                </div>
            </app-card-v2>
        </div>
    </div>

    <div class="text-center" *ngIf="(paymentRequestFindAllService.loading$ | async) else notLoading">
        <app-loading></app-loading>
    </div>
    <ng-template #notLoading>
        <div class="col-12">
            <app-error-card *ngIf="amount > balance"
                            message="Attention, le montant introduit dépasse le solde de la demande de paiement">

            </app-error-card>
        </div>
        <ng-container *ngIf="balance > 0">
            <div class="col-12">
                <strong>Solde:<app-price-label [price]="balance"></app-price-label></strong>
            </div>
            <app-accounting-movement-create-form #form
                                                 (amountChanged)="amountChanged($event)"
                                                 (selectedPaymentTypeChangedEvent)="selectedPaymentType = $event"
                                                 [amount]="balance"
                                                 [formGroup]="formGroup"
                                                 [movementType]="movementType"
                                                 [partnerId]="dialog.input.partnerId"
                                                 [label]="dialog.input.labelValue"
            ></app-accounting-movement-create-form>
        </ng-container>
    </ng-template>

    <app-button dialog-actions [disabled]="!formGroup?.valid || !balance || amount > balance" fill="solid"
                color="primary" label="Ajouter" [loading]="loading"
                (clickEvent)="save()" *ngIf="selectedPaymentType === 'OTHER'"></app-button>
    <!-- <app-action-button dialog-actions [disabled]="!formGroup?.valid" fill="solid"
                       iconName="card"
                       label="Initier le paiement sur le lecteur de carte"
        [service]="paymentRequestOnlineAttemptAddByCardActionService"
                       [buildPayload]="buildAttemptPayload"
                       (actionSuccessEvent)="attemptSuccess($event)"
                       [confirmationOptions]="undefined"
                       actionErrorMessage="Le paiement n'a pu être envoyé sur le lecteur de carte"
                       *ngIf="paymentRequest && selectedPaymentType === 'CARD_READER'"></app-action-button>-->

</app-dialog>